module.exports = require("./pt-PT");